import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'lsq-footer',
    template: `
        <div class="footer" [ngClass]="{ 'gray-footer-bg': isGray }">
            <div class="footer-badges">
                <img
                    class="footer-badge"
                    alt="AICPA SOC compliant"
                    height="40px"
                    [src]="assetsPath + '/images/general/aicpa.png'"
                />
                <img
                    class="footer-badge"
                    alt="Norton Secured"
                    height="40px"
                    [src]="assetsPath + '/images/general/norton.png'"
                />
                <a
                    class="footer-badge"
                    href="//privacy.truste.com/privacy-seal/validation?rid=8451a63b-c322-4a3d-a08c-a1647a86c2ff"
                    target="_blank"
                >
                    <img
                        height="30px"
                        style="border: none"
                        src="//privacy-policy.truste.com/privacy-seal/seal?rid=8451a63b-c322-4a3d-a08c-a1647a86c2ff"
                        alt="TRUSTe"
                    />
                </a>
            </div>
            <p class="footer-text text-center">
                LSQ, LSQ Funding, LSQ Funding Group and Transaction Management System are registered
                trademarks of LSQ Funding Group, L.C.
                <br />
                All other trademarks are the property of their respective owners. ©
                {{ currentYear }} LSQ Funding Group, L.C. All rights reserved
            </p>
            <div class="links-container">
                <lsq-button appearance="transparent" [tabindex]="'-1'">
                    <a href="https://www.lsq.com/privacy" target="_blank">
                        Privacy Policy
                    </a>
                </lsq-button>
                <lsq-button appearance="transparent" [tabindex]="'-1'">
                    <a href="https://www.lsq.com/terms" target="_blank">
                        Terms of Service
                    </a>
                </lsq-button>
                <lsq-button appearance="transparent" [tabindex]="'-1'">
                    <a href="https://www.lsq.com/esign" target="_blank">
                        E-Sign
                    </a>
                </lsq-button>
            </div>
        </div>
    `,
    styleUrls: ['./lsq-footer.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LsqFooterComponent {
    @Input() public isGray = false;
    public assetsPath = 'libs/common-ui/src/assets';
    public currentYear = new Date().getFullYear().toString();
}
